const homeSelector = state => state.environments.fhe.data.Homes.get('list');
const userInitialized = state => state.environments.fhe.data.Users.get('initialized');

export default {
    getHomes: homeSelector,
    getUsersInitialized: userInitialized
};



// WEBPACK FOOTER //
// ./environments/fhe/scenes/User/selectors.js